import React from "react"
import { Link } from "gatsby"
import "./style.css"
import useLang from "../../hooks/useLang"
import MainAreaSection from "../MainAreaSection"

export default function AboutMainArea({ image, title, description }) {
  const isAr = useLang() === "ar"
  return (
    <MainAreaSection
      img={image}
      title={""}
      currentPage={isAr ? "عن بنشمارك" : "About"}
      style={{
        fontFamily: '"Bukra", Tahoma, Arial, sans-serif',
      }}
    >
    </MainAreaSection>
  )
}
